import { cn } from "@/lib/cn";

import { HStack, Spacer } from "../Layout";
import { Label } from "../ui/label";
import { RadioGroupItem } from "../ui/radio-group";

interface CustomRadioButtonProps {
  /**
   * ラジオボタンの値選択された際に返される値です
   */
  value: string;

  /**
   * ラジオボタンが選択されているかどうかを示すフラグ
   */
  checked: boolean;

  /**
   * ラジオボタンに表示するラベルのテキスト
   */
  label: string;

  /**
   * ラジオボタンの選択状態が変わった際に呼び出されるコールバック関数
   * @param value 現在のラジオボタンの値
   */
  onChange: (value: string) => void;
}

/**
 * カスタムラジオボタンコンポーネント
 * このコンポーネントは、ラジオボタンとその隣に表示されるラベルを持ち、
 * `HStack`レイアウトを使用して水平に配置されます
 */
function CustomRadioButton({
  value,
  checked,
  label,
  onChange,
}: CustomRadioButtonProps) {
  return (
    <HStack className="items-center p-2">
      <RadioGroupItem
        value={value}
        className="h-4 w-4"
        checked={checked}
        onChange={() => onChange(value)}
        id={value}
      />
      <Spacer />
      <Label
        htmlFor={value}
        className={cn("cursor-pointer text-label text-primary-on-neutral-fill")}
      >
        {label}
      </Label>
    </HStack>
  );
}

export default CustomRadioButton;
